<script setup>
import { watch } from 'vue';
import { ref } from 'vue';
const props = defineProps({
  searchType: {
    type: String || Boolean,
    default: '1',
  },
  type: {
    type: String,
    default: 'string',
  }
})
const { searchType } = toRefs(props);

const emit = defineEmits('searchType', 'search');

const localSearchType = ref('1');

const handleSearchTypeChange = () => {
  // 向父组件传递选中的 searchType并且请求接口
  emit('update:searchType', localSearchType.value);
  emit('search');
};

watch(searchType, (newVal) => {
  localSearchType.value = newVal;
});
</script>

<template>
  <el-radio-group v-model="localSearchType" @change="handleSearchTypeChange" style="width: 100%;">
    <el-radio :label="type === 'string' ? '1' : false">部分一致</el-radio>
    <el-radio :label="type === 'string' ? '2' : true">完全一致</el-radio>
  </el-radio-group>
</template>